<template>
  <div class="collection">
    <h2 class="collection__title">
      {{ title }}
    </h2>

    <Slider
      class="collection__products"
      :items="products"
    >
      <ButtonDefault
        slot="previous"
        class="collection__left"
        arrow="left"
        :negative="true"
        :border="true"
        :theme="theme"
      />

      <ButtonDefault
        slot="next"
        class="collection__right"
        arrow="right"
        :negative="true"
        :border="true"
        :theme="theme"
      />

      <template v-slot:item="{ item: product }">
        <ProductLink
          v-if="product"
          :product="product"
          :theme="theme"
          class="collection__product"
        />
      </template>
    </Slider>
  </div>
</template>

<script>
import ProductLink from '@/components/items/ProductLink.vue';
import Slider from '@/components/Slider.vue';
import ButtonDefault from '@/components/buttons/ButtonDefault.vue';

export default {
  components: {
    ProductLink,
    Slider,
    ButtonDefault,
  },

  props: {
    title: { type: String, default: null },
    products: { type: Array, default: null },
    theme: { type: String, default: null },
  },
};
</script>

<style lang="stylus" scoped>
.collection {
  position: relative;
}

.collection__title {
  @extend $typo-collection-title;

  position: absolute;
  margin-top 60px;

  width 100%;

  color $cl-gold;
  text-align: center;
  text-transform: uppercase;
}
.collection__products {
  overflow: auto;
  box-sizing: border-box;
  padding: 117px 0px 40px 0px;

  +desktop() {
    padding: 162px 0px 70px 0px;
  }
}

.collection__product {
  padding: 0px;
  width: 320px;
  box-sizing: border-box;

  +desktop() {
    padding: 0px 70px 0px 70px;
    width: 344px;
  }
}

.collection >>> .slider__navigation {
  position: absolute;
  top: calc(50% - 21px);
  left: 0;
  right: 0;

  +pointer-device() {
    display: none;
  }
}

.collection__left {
  position: absolute;
  left: 50px;
}

.collection__right {
  position: absolute;
  right: 50px;
}
</style>
